export default __webpack_public_path__ + "static/media/5_vaultOfGems.1676f819.png";